module.exports = __webpack_public_path__ + "img/rpqnrcyz.b0df2176.png";